import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import DataDisplay from '../../../../components/DataDisplay';
import { emptyConstancyService } from '../../../../emptyObjects';
import { ConstancyService, DataDisplayItem } from '../../../../interfaces';
import { AppContext } from '../../../../context/AppContext';

interface Props {
  constancy: ConstancyService
}

const ConstancyServiceDetailGeneralInfo: React.FC<Props> = (props) => {
  const {
    constancy = emptyConstancyService
  } = props;

  const {
    userRole
  } = useContext(AppContext);

  const { t } = useTranslation();

  const dataItems: DataDisplayItem[] = [
    {
      label: t('services.serviceNumber'),
      value: constancy.requestNumber,
      format: 'none'
    },
    {
      label: t('global.status.title'),
      value: constancy.status,
      format: 'status'
    },
    {
      label: t('global.client'),
      value: constancy.client.businessName,
      format: 'none',
      navigateRoute: `/client/detail/${constancy.client.id}`,
      onlyAdmin: true
    },
    {
      label: t('global.collaborator'),
      value: constancy.collaborator.name,
      format: 'none'
    },
    {
      label: t('global.proposedValidationDate'),
      value: constancy.proposedValidationDate || '',
      format: 'date'
    },
    {
      label: t('global.creationDate'),
      value: constancy.createdAt,
      format: 'date-time'
    },
    {
      label: t('global.expirationDate'),
      value: constancy.createdAt,
      format: 'constancy-expired-date'
    },
    {
      label: t('services.requestIsCompleted'),
      value: constancy.indicators.requestIsCompleted,
      format: 'boolean'
    },
    {
      label: t('global.urgent'),
      value: constancy.indicators.urgent,
      format: 'boolean'
    }
  ];

  const getItems = (): DataDisplayItem[] => {
    if (['finance', 'master'].includes(userRole)) {
      dataItems.push(
        {
          label: t('global.invoiced'),
          value: constancy.indicators.invoiced,
          format: 'boolean'
        },
        {
          label: t('global.invoiceNumber'),
          value: constancy.indicators.invoicedInfo.invoiceNumber,
          format: 'none'
        },
        {
          label: t('global.dateBilling'),
          value: constancy.indicators.invoicedInfo.date,
          format: 'date'
        },
        {
          label: 'UUID',
          value: constancy.indicators.invoicedInfo.UUID,
          format: 'none'
        }
      );
      return dataItems;
    }

    return dataItems;
  };

  return (
    <DataDisplay
      dataTitle={t('services.generalInformation')}
      items={getItems()}
    />
  );
};

export default ConstancyServiceDetailGeneralInfo;
